module.exports = __webpack_public_path__ + "img/warnings-intro.09e7b2b2.jpg";